import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a58fd1ce&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a58fd1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58fd1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a58fd1ce')) {
      api.createRecord('a58fd1ce', component.options)
    } else {
      api.reload('a58fd1ce', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a58fd1ce&scoped=true&", function () {
      api.rerender('a58fd1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2A7KW0VmcxbPA/JS/comp/PopupBox.vue"
export default component.exports